import { render, staticRenderFns } from "./TerminalStats.vue?vue&type=template&id=b3431034"
import script from "./TerminalStats.vue?vue&type=script&lang=js"
export * from "./TerminalStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports